export default [
  { prop: 'data.date', header: 'Date' },
  { prop: 'data.message', header: 'Message' },
  { prop: 'data.sent', header: 'Sent' },
]
